import store from '@/store'

const isAuthScapeGuard = async ( to, from, next ) => {
    const { success, model } = await store.dispatch('auth/checkAuthentication')

    if ( success ) {
        if (model?.staffer) {
            next({ name: 'dashboard.reports.inventory.index' })
        } else {
            next({ name: 'dashboard.generalInventory.index' })
        }
    } 
    else {
        next()
    }
}

export default isAuthScapeGuard